<template>
  <div
    class="icon-outer-wrap"
    v-if="svgIcon"
    :style="{ width: width + 'px', height: width + 'px' }"
  >
    <div class="icon-wrap">
      <img :src="svgIcon" alt="icono" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LargeCircleIcon",
  props: {
    icon: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: 120
    }
  },
  computed: {
    svgIcon() {
      return this.icon ? require(`@/assets/img/1x/${this.icon}.svg`) : null;
    }
  }
};
</script>

<style scoped>
.icon-outer-wrap {
  display: inline-block;
}
.icon-wrap {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  padding: 21px;
  border-radius: 100%;
}

img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
